var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51 17.6C7.91 17.6 8.3 17.57 8.68 17.51C8.49 17.11 8.35 16.69 8.27 16.24C8.02 16.27 7.77 16.29 7.51 16.29C4.08 16.29 1.31 13.52 1.31 10.09C1.31 6.66 4.09 3.89 7.51 3.89C10.93 3.89 13.6 6.56 13.71 9.89C14.17 9.91 14.6 9.99 15.03 10.11V10.08C15.03 8.31 14.41 6.68 13.39 5.4C13.33 5.32 13.33 5.21 13.4 5.13L14.48 4.05C14.18 3.72 13.88 3.42 13.56 3.12L12.48 4.22C12.41 4.29 12.29 4.3 12.21 4.23C10.92 3.18 9.29 2.56 7.52 2.56C3.36 2.57 0 5.94 0 10.09C0 14.24 3.36 17.6 7.51 17.6Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87965 0H5.13965V1.31H9.87965V0Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17035 6H6.86035V10.74H8.17035V6Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2404 13.72L15.5004 12.82L12.5804 15.74C12.5004 15.82 12.3804 15.82 12.3004 15.74L11.0804 14.52L10.3604 15.24L12.4504 17.52L16.2504 13.72H16.2404Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e32f90cd2b10a94b20ddebdaa44cf146.svg";
export { ForwardRef as ReactComponent };